import { ILocationResponse } from '@customTypes/modelResponses'
import useAppContext from '@hooks/useAppContext'
import { useMemo } from 'react'
import Card from '@libs/cards/Card'

interface IDestinationsProps {
  data: ILocationResponse[] | undefined
  description?: string
  hasRaQ: boolean
}

function Destinations(props: IDestinationsProps): JSX.Element {
  const { isMobile } = useAppContext()

  const cardComponents = useMemo(() => {
    return props?.data?.map((location) => (
      <Card
        key={location?.id}
        id={location?.id}
        title={location?.Title}
        blurb={location?.Blurb}
        url={`/${location?.SEO?.Slug}`}
        // opensNewTab
        image={
          location?.Media?.PrimaryImage?.length &&
          location?.Media?.PrimaryImage[0]
        }
        imageSize={isMobile ? 'none' : 'xsmall'}
        isHorizontal
        isTitleLocation
      />
    ))
  }, [props.data, isMobile])

  return (
    <div
      className={`${
        props.hasRaQ ? '' : 'desktop:max-w-[750px]'
      } mb-8 desktop:mb-12`}
    >
      <h2 className='mb-4 text-h2 font-semibold'>Destinations</h2>
      {props.description && (
        <p className='mb-8 hidden text-p font-normal desktop:block'>
          {props.description}
        </p>
      )}
      <div className='flex flex-col gap-2 desktop:gap-8'>{cardComponents}</div>
    </div>
  )
}

export default Destinations
